<template>
  <div>
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="0"
      controls
      indicators
      background="#000"
      img-width="1024"
      img-height="480"
      style="text-shadow: 1px 1px 2px #333; 
    margin-left: -15px;
    margin-right: -15px;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <b-carousel-slide
        tag="article"
        class="m-5"
        v-if="loading"
        style="height:500px"
        caption="loading"
      >
        <div class="col text-center">
          <b-spinner label="Spinning"></b-spinner>
        </div>
      </b-carousel-slide>
      <b-carousel-slide
        v-else
        v-for="banner in banners"
        :key="banner.id"
         :class="banner.posicion[0]"
        :caption="banner.contenido"
        :text="banner.sub_titulo"
        :img-src="banner.photo.guid"
         style="text-shadow: 1px 1px 2px #f3f3f3;"
      ></b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import axios from "axios";
import config from "../../public/data/config.json";
export default {
  name: "Banners",
  async mounted() {
    this.loading = true;
    try {
      const results = await axios.get(config.URL + "/banner");
      this.banners = results.data.sort((a, b) => a.order - b.order);
      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  },
  data() {
    return {
      loading: false,
      banners: [],
      slide: 0,
      sliding: null,
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    onSlideStart(slide) {
      this.sliding = true;
      // eslint-disable-next-line no-undef
      pause();
    },
    // eslint-disable-next-line no-unused-vars
    onSlideEnd(slide) {
      this.sliding = false;
    }
  }
};
</script>

<style>

.carousel-control-prev,
.carousel-control-next {
  bottom: 25px !important;
  align-items: flex-end !important;
}
.carousel-item {
  background-color: #000000;
}
.carousel-item img {
  opacity: 0.8;
}
.carousel-control-prev-icon,
.carousel-control-next-icon {
  width: 40px !important;
  height: 40px !important;
  opacity: 1 !important;
}
.carousel-control-prev-icon {
  background-image: url("data:image/svg+xml,%3Csvg class='bi bi-arrow-left' width='1em' height='1em' viewBox='0 0 20 20' fill='white' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' d='M7.854 6.646a.5.5 0 010 .708L5.207 10l2.647 2.646a.5.5 0 01-.708.708l-3-3a.5.5 0 010-.708l3-3a.5.5 0 01.708 0z' clip-rule='evenodd'/%3E%3Cpath fill-rule='evenodd' d='M4.5 10a.5.5 0 01.5-.5h10.5a.5.5 0 010 1H5a.5.5 0 01-.5-.5z' clip-rule='evenodd'/%3E%3C/svg%3E") !important;
}

.carousel-control-next-icon {
  background-image: url("data:image/svg+xml,%3Csvg class='bi bi-arrow-right' width='1em' height='1em' viewBox='0 0 20 20' fill='white' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' d='M12.146 6.646a.5.5 0 01.708 0l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.708-.708L14.793 10l-2.647-2.646a.5.5 0 010-.708z' clip-rule='evenodd'/%3E%3Cpath fill-rule='evenodd' d='M4 10a.5.5 0 01.5-.5H15a.5.5 0 010 1H4.5A.5.5 0 014 10z' clip-rule='evenodd'/%3E%3C/svg%3E") !important;
}
.carousel-indicators li {
  opacity: 1 !important;
  border: 1px solid #a3a3a3 !important;
}
.carousel-indicators {
  bottom: -30px !important;
}
.carousel-indicators .active {
  opacity: 1;
  background-color: #aac90e !important;
  border: 1px solid #aac90e !important;
}
 .carousel-caption {
   text-shadow: none;
     bottom:20%!important;
}
.leftBottom .carousel-caption {
    text-align: left;
}
.centerBottom .carousel-caption {
    text-align: center;
}
.rightBottom .carousel-caption {
    text-align: right;
}
/* If the screen size is 601px wide or more, set the font-size of <div> to 80px */
@media screen and (min-width: 900px) {
 .carousel-caption h3 {
  font-size: 3.5vw;
}
.carousel-caption p {
  font-size: 2vw;
}
}

/* If the screen size is 600px wide or less, set the font-size of <div> to 30px */
@media screen and (max-width: 899px) {
 .carousel-caption h3 {
  font-size: 6vw;
}
.carousel-caption p {
  font-size: 3vw;
}

}
@media screen and (max-width: 600px) {
 .carousel-caption h3 {
  font-size: 5vw;
}
.carousel-caption {
    bottom: 0!important;
}

}
</style>